import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const SiteHeader = styled.header`
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;
  box-shadow: 0 10px 30px rgba(17, 24, 39, 0.06);
  position: sticky;
  top: 0;
  z-index: 999;
`;

export const TopBar = styled.div`
  align-items: center;
  background: #1f242b;
  color: #f8fafc;
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  overflow: hidden;
  padding: 0.55rem max(1.25rem, calc((100vw - 1180px) / 2 + 1.25rem));

  @media (max-width: 768px) {
    align-items: flex-start;
    flex-direction: column;
    gap: 0.35rem;
    max-width: 100vw;
    padding: 0.65rem 1rem;
    width: 100%;
  }
`;

export const TopBarText = styled.p`
  color: #dbe4ee;
  font-size: 0.88rem;
  font-weight: 600;
  margin: 0;
  max-width: 100%;
  min-width: 0;
  overflow-wrap: break-word;
  width: 100%;
`;

export const TopBarLinks = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.85rem;
  max-width: 100%;
  min-width: 0;

  a {
    color: #ffffff;
    font-size: 0.88rem;
    font-weight: 700;
    overflow-wrap: anywhere;
    text-decoration: none;
  }

  a:hover,
  a:focus-visible {
    color: #60a5fa;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const NavWrapper = styled.nav`
  align-items: center;
  display: flex;
  gap: 2rem;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 1180px;
  min-height: 82px;
  padding: 0.8rem 1.25rem;
  position: relative;

  @media (max-width: 768px) {
    display: grid;
    gap: 0.75rem;
    grid-template-columns: minmax(0, 1fr) auto;
    min-height: 74px;
  }
`;

export const NavBrand = styled(Link)`
  align-items: center;
  color: #1f242b;
  display: inline-flex;
  gap: 0.85rem;
  min-width: 0;
  text-decoration: none;

  @media (max-width: 768px) {
    overflow: hidden;
  }
`;

export const NavLogo = styled.img`
  background: #ffffff;
  border-radius: 8px;
  display: block;
  height: 54px;
  object-fit: contain;
  width: 72px;

  @media (max-width: 430px) {
    height: 46px;
    width: 60px;
  }
`;

export const NavBrandText = styled.span`
  display: grid;
  gap: 0.1rem;
  min-width: 0;
  overflow: hidden;

  strong {
    color: #1f242b;
    font-size: 1.28rem;
    font-weight: 900;
    line-height: 1;
    white-space: nowrap;
  }

  span {
    color: #667085;
    font-size: 0.85rem;
    font-weight: 700;
    text-transform: uppercase;
  }

  @media (max-width: 430px) {
    strong {
      font-size: 1.08rem;
    }

    span {
      font-size: 0.72rem;
    }
  }

  @media (max-width: 380px) {
    strong {
      font-size: 1rem;
    }
  }
`;

export const NavMenu = styled.ul`
  align-items: center;
  display: flex;
  gap: 0.25rem;
  list-style: none;
  margin: 0;
  padding: 0;

  @media (max-width: 768px) {
    background: #ffffff;
    border-top: 1px solid #e5e7eb;
    box-shadow: 0 18px 30px rgba(17, 24, 39, 0.08);
    display: ${(props) => (props.isOpen ? 'grid' : 'none')};
    flex-direction: column;
    gap: 0.3rem;
    left: 0;
    padding: 1rem 1.25rem 1.25rem;
    position: absolute;
    right: 0;
    top: 100%;
    width: 100%;
  }
`;

export const NavItem = styled.li`
  align-items: center;
  display: flex;

  a {
    border-radius: 8px;
    color: #374151;
    display: inline-flex;
    font-size: 0.96rem;
    font-weight: 800;
    padding: 0.75rem 0.9rem;
    text-decoration: none;

    &:hover,
    &:focus-visible,
    &.active {
      background: #f3f4f6;
      color: #1f242b;
    }
  }

  @media (max-width: 768px) {
    width: 100%;

    a {
      justify-content: center;
      width: 100%;
    }
  }
`;

export const NavCta = styled(Link)`
  background: #2563eb !important;
  color: #ffffff !important;
  margin-left: 0.35rem;

  &:hover,
  &:focus-visible {
    background: #1d4ed8 !important;
    color: #ffffff !important;
  }

  @media (max-width: 768px) {
    margin-left: 0;
  }
`;

export const Hamburger = styled.button`
  background: #1f242b;
  border: 0;
  border-radius: 8px;
  cursor: pointer;
  display: none;
  flex: 0 0 auto;
  padding: 0.55rem;

  @media (max-width: 768px) {
    align-items: center;
    display: grid;
  }
`;

export const HamburgerLine = styled.div`
  width: 25px;
  height: 3px;
  background-color: #fff;
  margin: 3px 0;
  border-radius: 999px;
  transition: transform 0.3s ease-in-out;

  ${(props) => props.isOpen && `transform: rotate(45deg) translate(4px, 4px);`}

  &:nth-child(2) {
    ${(props) => props.isOpen && `opacity: 0;`}
  }

  &:nth-child(3) {
    ${(props) => props.isOpen && `transform: rotate(-45deg) translate(8px, -8px);`}
  }
`;
